<template>
  <div class="chat-input-box agentic-home-chat-input">
    <div class="chat-input-content">
      <textarea
        v-model="message"
        class="chat-input-field"
        :placeholder="placeholderText"
        @keydown="handleKeyPress"
        @input="handleInput"
        ref="chatInput"
        rows="3"
      ></textarea>
    </div>
    <div class="chat-input-actions">
      <button class="chat-action-btn attachment-btn" @click="handleAttachment">
        <v-icon size="16">mdi-paperclip</v-icon>
      </button>
      <button class="chat-action-btn send-btn" @click="handleSend" type="button" :disabled="loading">
        <v-progress-circular v-if="loading" indeterminate color="primary" size="20" width="2"></v-progress-circular>
        <img v-else :src="sendIcon" alt="Send" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatInputBox",
  props: {
    placeholderText: {
      type: String,
      default: "Let's create a dashboard...",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: "",
      sendIcon: require("@/assets/Images/Dashboard/send-2.png"),
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.chatInput) {
        this.$refs.chatInput.focus();
      }
    });
  },
  methods: {
    handleAttachment() {
      this.$emit("attach-file");
    },
    handleSend() {
      if (this.message.trim()) {
        this.$emit("send-message", this.message);
        this.message = "";
        this.$nextTick(() => {
          if (this.$refs.chatInput) {
            this.$refs.chatInput.focus();
          }
        });
      }
    },
    handleKeyPress(event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        this.handleSend();
      }
    },
    handleInput(event) {
      this.message = event.target.value;
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/chatInputBox.css';
</style>

